import { EquipmentMasterThemeModeConfig } from './types';

const dark: EquipmentMasterThemeModeConfig = {
  equipmentMaster: {},
};

export default dark;
